<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <div class="row col-6 mb-3">
          <Button
            v-if="$store.getters.controllers?.history_payment && $store.getters.controllers?.history_payment.includes('add')"
            label="Kích hoạt"
            @click="activePackage()"
            class="p-button-success main-style-button mr-3" 
          />
          <DropdownScrollable :loading="loading" cusClass="m-0" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent"/>
        </div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model.sync="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          v-on:action-click="onActionClicked"
          :company="company"
        ></BaseDatatable>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
    }
  },
  // mounted () {
  //   this.initParams();
  // },
  async created() {
    await this.initParams();
    await this.getListCompany();
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    'company'() {
      this.componentKey++;
    }
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      this.getListCompany();
    },
    // changeOffset(value) {
    //   this.offset = value;
    //   this.getListCompany();
    // },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    activePackage() {
      this.$router.push({path: "/admin/list-history-payment/add"});
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // if (this.role.add) {
        // actions.header = {name: 'add', icon: 'plus', path: `list-history-payment/add`};
      // }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        // if (that.role.edit) {
          // buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-history-payment/edit/`};
        // }
        // if (that.role.delete) {
          // buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
        // }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/packages/delete", {packages_id: that.deleteId}, {headers}).then(function () {
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            })
        })
      }
    }
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
</style>